import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  style: {"z-index":"50"},
  class: "absolute bottom-0 right-0 hidden mr-1 -mb-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-danger-dark material-icons-outlined" }, " delete ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!
  const _component_ExerciseEditor = _resolveComponent("ExerciseEditor")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative my-4",
    id: 'editor-' + _ctx.exercise.id
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Btn, {
        class: "mb-4",
        outline: true,
        size: 'lg',
        variant: 'icon',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.showEditor]
    ]),
    _withDirectives(_createVNode(_component_MinimalExercisePreview, {
      exercise: _ctx.exercise,
      hoverable: true,
      selectable: false,
      onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleExpand())),
      showEdit: _ctx.editable
    }, null, 8, ["exercise", "showEdit"]), [
      [_vShow, !_ctx.showEditor]
    ]),
    (_ctx.showEditor)
      ? (_openBlock(), _createBlock(_component_ExerciseEditor, {
          key: 0,
          saving: _ctx.saving,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleExpand())),
          modelValue: _ctx.exercise,
          onDelete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete'))),
          onCloneExercise: _ctx.onClone
        }, null, 8, ["saving", "modelValue", "onCloneExercise"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}